const { fontFamily } = require('tailwindcss/defaultTheme');

/** @type {import('tailwindcss').Config} \*/
module.exports = {
  content: ['./src/**/*.{js,ts,jsx,tsx}'],
  theme: {
    extend: {
      screens: {
        xs: '480px',
      },
      colors: {
        rose: {
          brightOnPurple: '#ff508a',
          bright: '#d25175',
          default: '#c53a68',
          500: '#c53a68',
          dark: '#84284b',
        },
        orange: {
          bright: '#ff8e24',
          default: '#f19939',
          500: '#f19939',
          dark: '#da7427',
          extraDark: '#b95b13',
        },
        neutral: {
          0: '#ffffff',
          100: '#f3f4f6',
          200: '#e5e7eb',
          300: '#d1d5db',
          400: '#9ca3b0',
          500: '#6b7281',
          600: '#4c5564',
          700: '#384152',
          800: '#202938',
          900: '#0f1727',
        },
        purple: {
          100: '#fbf9fb',
          200: '#ebe5eb',
          300: '#dbd1db',
          400: '#a095a1',
          500: '#7a6c7a',
          600: '#5f4d60',
          700: '#4d374f',
          800: '#3d1a3a',
          900: '#270f29',
        },
      },
      fontFamily: {
        sans: ['var(--font-rubik)', ...fontFamily.sans],
        mono: ['var(--font-mono)', ...fontFamily.mono],
      },
    },
  },
  plugins: [require('tailwindcss-safe-area')],
};
